module.exports = __webpack_public_path__ + "img/apartment-yellow.a3f0fd36.png";